module.exports = __webpack_public_path__ + "img/118.97266d3.jpg";